import { useLocation, useParams, useNavigate, Link } from 'react-router-dom';
import type { PublicBooking } from '../lib/types';
import { money, dateTime } from '../lib/format';

export function ConfirmationPage() {
  const { qrToken, bookingNumber } = useParams();
  const navigate = useNavigate();
  const state = (useLocation().state ?? {}) as { booking?: PublicBooking };
  const booking = state.booking;

  return (
    <div className="px-4 pb-16 pt-10 text-center">
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-emerald-100 text-emerald-600">
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4">
          <path d="M5 13l4 4L19 7" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
      <h1 className="mt-4 text-xl font-semibold text-ink-900">Booking received</h1>
      <p className="mt-1 text-sm text-ink-500">
        Our team will contact you shortly to confirm details and pricing.
      </p>

      <div className="card mx-auto mt-6 max-w-sm p-4 text-left">
        <div className="flex items-center justify-between">
          <span className="text-xs uppercase tracking-wide text-ink-400">Booking number</span>
          <span className="font-mono text-sm font-semibold text-ink-900">{bookingNumber}</span>
        </div>
        {booking && (
          <>
            <div className="mt-3 space-y-2 border-t border-ink-100 pt-3">
              {booking.items.map((it, i) => (
                <div key={i} className="flex justify-between text-sm">
                  <span className="min-w-0">
                    <span className="line-clamp-1">{it.productName}</span>
                    <span className="text-[11px] text-ink-400">
                      Qty {it.quantity} · Rack {it.rackNumber}
                    </span>
                  </span>
                  <span className="shrink-0 font-medium">{money(it.lineTotal)}</span>
                </div>
              ))}
            </div>
            <div className="mt-3 flex justify-between border-t border-ink-100 pt-3 text-sm font-semibold">
              <span>Estimated total</span>
              <span>{money(booking.totalAmount)}</span>
            </div>
            <p className="mt-2 text-[11px] text-ink-400">Placed {dateTime(booking.createdAt)}</p>
          </>
        )}
      </div>

      <div className="mx-auto mt-6 flex max-w-sm flex-col gap-2">
        <button className="btn-outline" onClick={() => navigate(`/r/${qrToken}`)}>
          Browse more pieces
        </button>
        <Link className="btn-ghost" to="/booking-lookup">
          Track this booking later
        </Link>
      </div>
    </div>
  );
}
